<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="product-single-container product-single-default product-quick-view container">
    <i class="icon-retweet btn-close" data-dismiss="modal"></i>
    <div class="row">
      <div class="col-md-6">
        <div class="label-group">
          <span
            class="product-discount"
            v-if="profile.discountDataVisible && getCurrentDiscount(quickArticle) != '0'"
          >
            {{ getCurrentDiscount(quickArticle) | percentage }}%
          </span>
        </div>
        <photo-gallery
          :gallery="variationGallery"
          v-if="variationGallery.length"
          :fullscreen-enabled="false"
        />
        <photo-gallery
          v-else-if="gallery.length"
          :gallery="gallery"
          :fullscreen-enabled="false"
        />
        <div v-else>
          <img src="assets/images/no-image.jpg" />
        </div>
        <!-- End .product-single-gallery -->
      </div>
      <!-- End .col-lg-7 -->

      <div class="col-lg-6 col-md-6 mt-2">
        <div class="product-single-details">
          <div class="single-product-cypher">
                <span class="cypher-title">{{ translations.forms.labels.code }}:</span>
                <span class="cypher-value">{{ selectedVariation?.code ?? quickArticle.code }}</span>
              </div>
          <h1 class="product-title">{{ quickArticle.title }}</h1>

          <div class="ratings-container">
            <star-rating
              :inline="true"
              :star-size="15"
              :read-only="true"
              :show-rating="false"
              :rating="quickArticle.rating"
            />
            <!-- End .product-ratings -->

            <span> ( {{ quickArticle.numberOfReviews }} Reviews ) </span>
          </div>
          <!-- End .product-container -->

          <div v-if="!quickArticle.disableSelling && canViewPrices">
            <div class="price-box">
              <!-- <span
                    class="text-primary price-discount"
                    v-if="profile.discountDataVisible && article.salePrice"
                  >
                </span> -->

              <span class="product-price" v-if="lowestVariationPrice > 0">
                {{ getCurrentPrice(quickArticle) | money3WithCurrencyRange }}
              </span>
              <span class="product-price" v-else>
                {{ getCurrentPrice(quickArticle) | money3WithCurrency }}
              </span>

              <span class="old-price" v-if="getOldPrice(quickArticle) > 0">
                <del> {{ getOldPrice(quickArticle) | money3 }} KM</del>
              </span>
            </div>
          </div>
          <!-- End .price-box -->

          <div class="product-desc">
            <p v-if="quickArticle.shortDescription"
              class="html-content"
              v-html="quickArticle.shortDescription">
            </p>
            <p v-else>N/A</p>
          </div>

          <div class="poduct-single-delivery available" v-if="quickArticle.stockAmount">
                <i class="icon-truck"></i>
                <span style="font-weight: 600"> Proizvod je dostupan. <br /> </span>
              </div>

              <div class="poduct-single-delivery not-available" v-if="!quickArticle.stockAmount">
                <i class="icon-truck"></i>
                <span style="font-weight: 600">
                  Proizvod je dostupan po narudžbi. <br />
                  <span v-if="quickArticle.articleAvailableInDays">
                    Vrijeme isporuke je {{ quickArticle.articleAvailableInDays }}
                    dana od narudžbe proizvoda
                  </span>
                </span>
              </div>

              <div v-if="(quickArticle.disableSelling ||
                      (!quickArticle.stockAmount && !allowOrderingStockZero)) &&
                    !canPassRestrictions" class="text-danger my-4">
                Artikal je dostupan po narudžbi. Molimo kontaktirajte Vašeg prodajnog predstavnika.
              </div>

          <div class="variations-wrapper">
                <div v-for="item in variations" :key="item.id"
                  class="variation-item"
                  :class="{
                    'selected-variation-color': isVariationSelected(item.id)
                      && variationContainsColor(item),
                    'selected-variation': isVariationSelected(item.id)
                      && !variationContainsColor(item),
                  }"
                  @click="selectVariation(item)">
                  <div
                    v-if="Object.keys(attributesObj).length > 0"
                    :class="{
                      'variation-combination-item-color': variationContainsColor(item),
                      'variation-combination-item': !variationContainsColor(item),
                      'active-variation': item.stockAmount > 0 && !isVariationSelected(item.id),
                      'inactive-variation': item.stockAmount === 0 && !isVariationSelected(item.id),
                      'selected-variation': isVariationSelected(item.id)
                        && !variationContainsColor(item),
                      'selected-variation-color': isVariationSelected(item.id)
                        && variationContainsColor(item),
                    }"
                  >
                    <div
                      v-for="attribute in item.variationCombinations"
                      :key="attribute.attributeId"
                    >
                      <div v-if="attributesObj[attribute.attributeId].attributeStyle === 1"
                      class="variation-item-secondary"
                      :style="{
                        'background-color': attributesObj[attribute.attributeId]
                        .attributeProperties.find(
                          (i) => attribute.attributeValueId === i.id)?.label
                      }">
                      </div>
                      <div v-else>
                      {{
                        attributesObj[attribute.attributeId].attributeProperties.find(
                        (i) => attribute.attributeValueId === i.id)?.label
                      }}
                    </div>
                    </div>
                  </div>
                </div>
              </div>
          <div class="product-action" v-if="!quickArticle.disableSelling || canPassRestrictions">
            <div class="product-single-qty">
              <div class="input-group bootstrap-touchspin">
                <span
                  class="input-group-btn input-group-prepend"
                  @click="setQuantity(-quickArticle.orderQuantityRatio)"
                >
                  <button class="btn btn-outline btn-down-icon" type="button" />
                </span>
                <input
                  class="horizontal-quantity form-control"
                  v-model.number="quantity"
                  @blur="handleQuantityChange"
                />
                <span
                  class="input-group-btn input-group-append"
                  @click="setQuantity(quickArticle.orderQuantityRatio)"
                >
                  <button class="btn btn-outline btn-up-icon" type="button" />
                </span>
              </div>
            </div>
            <!-- End .product-single-qty -->

            <button
              v-if="canPassRestrictions"
              class="paction add-cart"
              :title="translations.addToCart2"
              @click.prevent.stop="addToCart()"
            >
              {{ translations.addToCart2 }}
            </button>
            <button
              v-else-if="
                !quickArticle.disableSelling &&
                (quickArticle.stockAmount || allowOrderingStockZero)
              "
              class="paction add-cart"
              :title="translations.addToCart2"
              :class="{
                disabled: !quantity || !isStepValid(quantity, quickArticle.orderQuantityRatio),
              }"
              :disabled="!quantity || !isStepValid(quantity, quickArticle.orderQuantityRatio)"
              @click.prevent.stop="addToCart()"
            >
              {{ translations.addToCart2 }}
            </button>

            <a
              href="#"
              class="paction add-wishlist"
              title="Add to Wishlist"
              :class="{ active: quickArticle.isOnWishList }"
              @click.stop.prevent="toggleWishlistItem(quickArticle.id)"
            >
              <span>Add to Wishlist</span>
            </a>
          </div>
          <div v-else>
            <button
              v-if="
                (quickArticle.disableSelling ||
                  (!quickArticle.stockAmount && !allowOrderingStockZero)) &&
                !canPassRestrictions
              "
              class="paction add-cart"
              @click="showOutOfStockModal"
            >
            {{ translations.availableOnRequest }}
            </button>
          </div>
        </div>
        <!-- End .product-single-details -->
      </div>
      <!-- End .col-lg-5 -->
    </div>
    <!-- End .row -->
  </div>
</template>

<script>
// import Vue from 'vue';
import StarRating from 'vue-star-rating';
import { translations } from '@/mixins';
import helpers from '@/services/helpers';

import config from '@/config';
import api from '@/services/api';
import slugify from '@/filters/slugify';
import PhotoGallery from '../photo-gallery/PhotoGallery.vue';

export default {
  name: 'QuickArticle',
  mixins: [translations],
  components: {
    StarRating,
    PhotoGallery,
  },
  data() {
    return {
      attributeCombinations: [],
      quantity: 1,
      variationId: null,
      selectedVariation: null,
    };
  },
  computed: {
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    allowOrderingStockZero() {
      return this.$store.getters.getAllowOrderingStockZero;
    },
    gallery() {
      if (!this.quickArticle?.gallery) return [];

      return (
        this.quickArticle.gallery.images.map((item) => {
          const src = `${config.baseUrl}${item.url}`;
          const { id } = item;
          return {
            src,
            thumbnail: src,
            id,
          };
        }) || []
      );
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
    canPassRestrictions() {
      return this.profile?.userData?.articleAlwaysVisibleOnWeb;
    },
    variationGallery() {
      if (!this.selectedVariation?.gallery) return [];

      const images = this.selectedVariation.gallery.images.map((item) => {
        const src = `${config.baseUrl}${item.url}`;
        const { id, isHighlighted } = item;
        return {
          src,
          isHighlighted,
          thumbnail: src,
          id,
          largeViewSrc: src,
        };
      }) || [];

      return images.sort((x, y) => {
        if (x.isHighlighted === y.isHighlighted) {
          return 0;
        }
        if (!x.isHighlighted) {
          return 1;
        }
        return -1;
      });
    },
    variations() {
      return this.$store.getters.getArticleVariations;
    },
    lowestVariationPrice() {
      if (this.variations.length > 0) {
        return Math.min(...this.variations.map((item) => item.vpc));
      }
      return 0;
    },
    attributesObj() {
      return this.$store.getters.getAttributesAsObj;
    },
  },
  methods: {
    slugify,
    isStepValid(quantity, ratio) {
      const factor = quantity < 1 || ratio < 1 ? 10 : 1;

      return (quantity * factor) % (ratio * factor) === 0;
    },
    getCurrentPrice(item) {
      if (this.selectedVariation) {
        return this.selectedVariation.vpc;
      }

      const salePrice = item.salePrice || 0;
      const price = item.price || 0;

      if (salePrice > 0 && salePrice < price) {
        return salePrice;
      }
      return (price === 0 ? this.lowestVariationPrice : price) || 0;
    },
    getCurrentDiscount(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;
      const saleDiscountPercentage = item.saleDiscountPercentage || 0;
      const baseArticlePrice = item.baseArticlePrice || 0;
      if (salePrice > 0 && salePrice < price) {
        return saleDiscountPercentage * -1;
      }
      if (matchedPP) {
        return (100 * (1 - (price / baseArticlePrice)) || 0) * -1;
      }
      return 0;
    },
    getOldPrice(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;
      const baseArticlePrice = item.baseArticlePrice || 0;
      if (salePrice > 0 && salePrice < price) {
        return (baseArticlePrice === 0 ? price : baseArticlePrice) || 0;
      }
      if (matchedPP) {
        return baseArticlePrice;
      }
      return 0;
    },
    showOutOfStockModal() {
      this.$store.dispatch('showOutOfStockModal', { articleId: this.quickArticle.id });
    },
    isAttributeCombinationActive({ attributeId, attributeValueId }) {
      return this.attributeCombinations.some(
        (i) => i.attributeId === attributeId && i.attributeValueId === attributeValueId,
      );
    },
    setQuantity(num) {
      let { minOrderQuantity, maxOrderQuantity, orderQuantityRatio } = this.quickArticle;

      minOrderQuantity = minOrderQuantity || 1;
      maxOrderQuantity = maxOrderQuantity || Infinity;
      orderQuantityRatio = orderQuantityRatio || 1;

      if (this.quantity <= minOrderQuantity && num === -minOrderQuantity) return;
      if (num >= orderQuantityRatio && this.quantity === maxOrderQuantity) return;
      this.quantity = parseFloat((this.quantity + num).toFixed(1), 10);

      if (this.quantity < minOrderQuantity) {
        this.quantity = minOrderQuantity;
      }

      if (this.quantity > maxOrderQuantity) {
        this.quantity = maxOrderQuantity;
      }
    },
    handleQuantityChange() {
      let { minOrderQuantity, maxOrderQuantity, orderQuantityRatio } = this.quickArticle;

      minOrderQuantity = minOrderQuantity || 1;
      maxOrderQuantity = maxOrderQuantity || Infinity;
      orderQuantityRatio = orderQuantityRatio || 1;

      const numOfDecimals = orderQuantityRatio.toString().split('.');
      const roundTo = numOfDecimals.length > 1 ? numOfDecimals[1].length : 0;
      const num = parseFloat(this.quantity.toFixed(roundTo), 10);
      let ratio = parseFloat((num % orderQuantityRatio).toFixed(roundTo), 10);

      if (ratio < minOrderQuantity) {
        if (num > minOrderQuantity) {
          ratio = parseFloat(((num - minOrderQuantity) % orderQuantityRatio).toFixed(roundTo), 10);
        } else {
          ratio = parseFloat(((minOrderQuantity - num) % orderQuantityRatio).toFixed(roundTo), 10);
        }
      }

      // if (ratio !== 0) {
      //   console.log('ratio: ', ratio);
      //   // when ratio is integer
      //   if (Number.isInteger(orderQuantityRatio)) {
      //     this.quantity = parseFloat((this.quantity - ratio).toFixed(roundTo), 10);
      //   } else {
      //     this.quantity = parseFloat(this.quantity, 10);
      //   }
      // }

      // when ratio is integer
      if (!Number.isInteger(orderQuantityRatio)) {
        this.quantity = parseFloat(this.quantity, 10);
      } else {
        this.quantity = parseFloat((this.quantity - ratio).toFixed(roundTo), 10);
      }

      if (this.quantity < minOrderQuantity) {
        this.quantity = minOrderQuantity;
      }

      if (this.quantity > maxOrderQuantity) {
        this.quantity = maxOrderQuantity;
      }
    },
    addAttributeCombinations(payload) {
      const { attributeCombinations } = this;
      const alreadyExists = this.attributeCombinations.some(
        (item) => item.attributeId === payload.attributeId
        && item.attributeValueId === payload.attributeValueId,
      );

      if (!alreadyExists) {
        const index = attributeCombinations.findIndex((i) => i.attributeId === payload.attributeId);

        if (index === -1) {
          this.attributeCombinations.push(payload);
        } else {
          attributeCombinations[index].attributeValueId = payload.attributeValueId;
        }
      }
    },
    addToCart() {
      // if (this.attributeCombinations.length !== this.quickArticle.articleAttributes.length) {
      //   this.$toast.error('Morate izabrati sve kombinacije');
      //   return;
      // }
      if (
        this.quickArticle.hasAttributes
        || (!this.quickArticle.stockAmount && !this.allowOrderingStockZero)
      ) {
        $('#quick-preview-article').modal('hide');
        this.$router.push({ name: 'Article', params: { id: this.quickArticle.id, slug: slugify(this.quickArticle.title) } });
        return;
      }

      if (this.variations.length > 0 && !this.selectedVariation) {
        this.$toast.info('Morate odabrati barem jednu varijaciju artikla!');
        return;
      }

      api
        .addToShoppingCart({
          articleId: this.quickArticle.id,
          quantity: this.quantity,
          attributeCombinations: [],
          variationId: this.variationId,
        })
        .then((response) => {
          if (this.quantity === this.quickArticle.minOrderQuantity) {
            this.$toast.info(helpers.getAddToCartToastMessage(this.quickArticle));
          } else {
            this.$toast.info(response.data.info);
          }
          this.$store.dispatch('getShoppingCart');
          $('#quick-preview-article').modal('hide');
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
          this.$store.dispatch('getShoppingCart');
          $('#quick-preview-article').modal('hide');
        });
    },
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getQuickViewArticle', articleId);
        this.$store.dispatch('getWishList');
      });
    },
    isVariationSelected(variationId) {
      return this.variationId === variationId;
    },
    variationContainsColor(variation) {
      return variation.variationCombinations.length === 1 && variation.variationCombinations.some(
        (i) => this.attributesObj[i.attributeId]?.attributeStyle === 1,
      );
    },
    selectVariation(variation) {
      if (variation.stockAmount === 0) {
        this.$toast.info('Odabrani artikal trenutno nije na stanju!');
        return;
      }
      if (this.variationId === variation.id) {
        this.variationId = null;
        this.selectedVariation = null;
        this.attributeCombinations = this.attributeCombinations.filter(
          (i) => i.attributeId !== variation.attributeId,
        );
      } else {
        this.variationId = variation.id;
        api.getVariationById(variation.id).then((response) => {
          this.selectedVariation = response.data.data;
          this.attributeCombinations = [];
          response.data.data.variationCombinations.forEach((item) => {
            this.attributeCombinations.push(item);
          });

          variation.variationCombinations.forEach((comb) => {
            this.attributeCombinations.push(comb);
          });
        });
      }
    },
  },
  mounted() {
    this.$store.dispatch('getArticleVariations', this.quickArticle.id);
    this.attributeCombinations = [];
    this.quantity = this.quickArticle.minOrderQuantity || 1;
  },
  destroyed() {
    this.attributeCombinations = [];
    this.quantity = this.quickArticle.minOrderQuantity || 1;
  },
};
</script>

<style lang="scss">
@media screen and (min-width: 992px) {
  #quick-preview-article > .modal-dialog {
    max-width: 1000px;
  }
}

.btn-close {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #000;
  font-size: 2.5rem;
  cursor: pointer;
  z-index: 1;
}

.paction.add-cart {
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.config-swatch-list li {
  border: 1px solid #e7e7e7;
}
.config-swatch-list li.active a:before {
  font-size: 1.6rem;
}
.product-discount {
  background-color: #e27c7c;
  color: white;
  max-width: 100px;
  line-height: 30px;
  padding: 5px 20px;
  font-weight: 700;
}
.variations-wrapper {
  display: flex;
  gap: 6px;
  margin-bottom: 15px;
}

.variation-item {
  margin-block: 4px;
}

.selected-variation {
  border: 1px solid #e7e7e7;
  border-radius: 4px;
}

.selected-variation-color {
  border: 1px solid #4882B9;
  padding: 4px;
  border-radius: 50%;
}

.variation-combination-item-color {
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  gap: 4px;
  border: 1px solid #e7e7e7;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.variation-combination-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  gap: 4px;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
}

.active-variation {
  background-color: #fff;
  color: #4882B9;
}

.inactive-variation {
  background-color: #f5f5f5;
  color: #9c9b9b;
}

.selected-variation .variation-combination-item {
  background-color: #4882B9;
  color: #fff;
}

.variation-combination-item:hover {
  cursor: pointer;
  color: #1e84bf;
  border: 1px solid #1e84bf;
  background-color: #EBF3F8;
}

.variation-item-secondary {
  width: 24px;
  height: 24px;
}

.html-content a {
  color: #3598DB;
}
</style>
